import { createStyles } from '@mantine/core'

export default createStyles((theme, _params, getRef) => ({
  root: {
    backgroundColor: theme.fn.rgba(theme.colors.gray[3], 0.5),
    padding: '4px 12px',
    borderRadius: '12px',
    maxWidth: '60%',
    [`@media (max-width: ${theme.breakpoints.md}px)`]: {
      maxWidth: '80%',
    },
  },
  report: {
    backgroundColor: theme.fn.rgba(theme.colors.gray[1], 0.4),
  },
  ratingRequestBabysitter: {
    maxWidth: '100%',
    width: '100%',
    backgroundColor: theme.white,
    border: '2px solid lightgrey',
    marginTop: '4px',
  },
  ratingRequestClient: {
    backgroundColor: theme.fn.rgba(theme.colors.secondary[8], 0.5),
  },
  highlight: {
    backgroundColor: theme.fn.rgba(theme.colors.secondary[theme.fn.primaryShade()], 0.5),
  },
  image: {
    display: 'flex',
    marginTop: '8px',
  },
  imageType: {
    maxHeight: '200px',
    maxWidth: '200px',
    cursor: 'pointer',
  },
  imagePopup: {
    maxHeight: '100vh',
    maxWidth: '100vw',
  },
  nameText: {
    fontSize: '16px',
    fontWeight: 'bold',
    color: 'primary',
  },
  automaticMessage: {
    fontSize: '10px',
    fontStyle: 'italic',
  },
}))
